<template>
  <section class="brand-value" aria-labelledby="brand-value-title">
    <div class="brand-value__visual">
      <img src="@/assets/images/photo_dirty_octo.jpeg" alt="" loading="lazy" decoding="async">
    </div>

    <div class="brand-value__content">
      <h2 id="brand-value-title">Why Fathom Ocean?</h2>

      <div class="brand-value__ledger">
        <article>
          <img src="@/assets/images/selfcleaning.png" alt="" loading="lazy" decoding="async">
          <div>
            <h3>Self-Cleaning Technology</h3>
            <p>Clear images for months—not days.</p>
          </div>
        </article>
        <article>
          <img src="@/assets/images/ai-alerts.png" alt="" loading="lazy" decoding="async">
          <div>
            <h3>AI Detection &amp; Alerts</h3>
            <p>Receive notifications when important events occur.</p>
          </div>
        </article>
        <article>
          <img src="@/assets/images/long-term.png" alt="" loading="lazy" decoding="async">
          <div>
            <h3>Built for Long-Term Deployment</h3>
            <p>Designed specifically for underwater environments.</p>
          </div>
        </article>
        <article>
          <img src="@/assets/images/remote-access.png" alt="" loading="lazy" decoding="async">
          <div>
            <h3>Remote Access</h3>
            <p>View your underwater world from anywhere.</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'BrandValue' }
</script>

<style lang="scss">
#app .brand-value {
  display: grid;
  min-height: 980px;
  grid-template-columns: minmax(0, 1.12fr) minmax(520px, 0.88fr);
  color: var(--white);
  background: var(--navy);
}

#app .brand-value__visual {
  min-height: 820px;
  overflow: hidden;
}

#app .brand-value__visual img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 56% center;
  filter: saturate(0.65) contrast(1.08) brightness(0.68);
}

#app .brand-value__content {
  display: flex;
  padding: clamp(96px, 9vw, 150px) clamp(44px, 6vw, 96px);
  flex-direction: column;
  justify-content: center;
}

#app .brand-value h2 {
  max-width: 8ch;
  margin-bottom: clamp(60px, 7vw, 96px);
  font-size: clamp(3.6rem, 6.1vw, 6.6rem);
  letter-spacing: -0.048em;
}

#app .brand-value__ledger {
  border-top: 1px solid var(--line-dark);
}

#app .brand-value__ledger article {
  display: grid;
  min-height: 138px;
  padding: 26px 0;
  border-bottom: 1px solid var(--line-dark);
  grid-template-columns: 44px 1fr;
  gap: 22px;
  align-items: center;
}

#app .brand-value__ledger img {
  width: 34px;
  height: 34px;
  object-fit: contain;
  opacity: 0.7;
  filter: grayscale(1) brightness(1.7);
}

#app .brand-value__ledger h3 {
  margin-bottom: 7px;
  font-size: clamp(1.35rem, 1.75vw, 1.7rem);
}

#app .brand-value__ledger p {
  margin: 0;
  color: #bdcbd2;
  font-size: 1.06rem;
}

@media (max-width: 1024px) {
  #app .brand-value {
    min-height: 0;
    grid-template-columns: minmax(0, 0.72fr) minmax(460px, 1fr);
  }
}

@media (max-width: 780px) {
  #app .brand-value { display: block; }
  #app .brand-value__visual {
    min-height: 0;
    height: min(110vw, 540px);
  }
  #app .brand-value__visual img { object-position: 57% center; }
  #app .brand-value__content { padding: 86px 20px 96px; }
  #app .brand-value h2 {
    margin-bottom: 54px;
    font-size: clamp(3.2rem, 14vw, 4.8rem);
  }
  #app .brand-value__ledger article {
    min-height: 0;
    grid-template-columns: 48px 1fr;
    gap: 18px;
  }
}
</style>
